export function isElementVisible(element) {
    const rect = element.getBoundingClientRect();
    const isVisible = rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
            (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth);
    return isVisible;
}
//# sourceMappingURL=isElementVisible.js.map